import { defineStore } from 'pinia'
import appConfig from '@/app.config'

export const useMainStore = defineStore('main', {
  state: () => ({
    mainCoinCode: appConfig.mainCoinCode
  })
})
